import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, SharedModule]
})
export class TermsComponent implements OnInit {

  buttonSelected: string = "Home";


  constructor() { }

  ngOnInit(): void {
  }

}
